/**
 * @generated SignedSource<<68a33790eef34b534818ac92f6a662fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeRoleEditEmployeesListItem_employee$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "EmployeeRoleEditEmployeesListItem_employee";
};
export type EmployeeRoleEditEmployeesListItem_employee$key = {
  readonly " $data"?: EmployeeRoleEditEmployeesListItem_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeRoleEditEmployeesListItem_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeRoleEditEmployeesListItem_employee",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "44dce5c6cf3aa9bc8f0039ab53865b22";

export default node;
